export default "__VITE_ASSET__ee976cc3__"